function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "SmartReply_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  className: "SmartReply_svg__a",
  transform: "translate(22 336)",
  d: "M0 0h24v24H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "SmartReply_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  className: "SmartReply_svg__c",
  d: "M1.433 20A1.433 1.433 0 010 18.567V5.433A1.433 1.433 0 011.433 4h21.134A1.432 1.432 0 0124 5.433v13.134A1.432 1.432 0 0122.567 20zm.067-1.5h21V6.29l-10.058 7.315a.745.745 0 01-.441.144.742.742 0 01-.441-.144L1.5 6.29zM12 12.073L21.038 5.5H2.962z"
}));

function SvgSmartReply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default SvgSmartReply;